import { createBrowserHistory } from 'history';

/**
 * Creates and installs the Connected History Router
 */
export default {
  id: 'molten.RouterInit',
  sort: -30,
  init: molten => {
    const basename = molten.getConfig('history/basename', '/');
    const history = createBrowserHistory({
      basename
    });
    molten.set('history', history);
  }
};